export const VENDOR_TYPES = ['Industry', 'Generator', 'DISCOM', 'State', 'Trader', 'CPP', 'IPP'];
